import * as Sentry from '@sentry/react';

import { router } from '@/App';

const sentryTraceSampleRate = Number.parseFloat(import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE ?? '0.1');
const tracesSampleRate = import.meta.env.MODE === 'development' ? 1.0 : sentryTraceSampleRate;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.MODE !== 'development' && !!import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['error'] }),
  ],
  tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0.1,
  enableLogs: true,
});
